import script from "./PoolDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PoolDetails.vue?vue&type=script&setup=true&lang=js"

import "./PoolDetails.vue?vue&type=style&index=0&id=7db7950f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db7950f"]])

export default __exports__